import React from 'react';
import { css } from '@emotion/react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';
import { CareRecordFormHook } from '@/hooks/useCareRecordForm';

interface Props {
  form: CareRecordFormHook;
}

const AlignCenter = css`
  display: flex;
  align-items: center;
`;

const InnerRowContainer = css`
  height: 72px;
`;

const Unit = css`
  min-width: 25px;
  font-size: 16px;
  text-align: right;
  margin: 16px 5px 0 5px;
  white-space: nowrap;
`;

export const CareRecordPadVolumeSection = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div css={[AlignCenter, InnerRowContainer]}>
      <TextField
        id='pad-volume-field'
        label={t('padUrineAmount', 'パッド排尿量')}
        type='number'
        value={form.padUrineVolume ?? ''}
        disabled={form.isPadVolumeDisabled}
        onChange={form.handleChangePadUrineVolume}
        fullWidth={true}
      />
      <span css={Unit}>ml</span>
    </div>
  );
};
